import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";
import DefaultFooter from "examples/Footers/DefaultFooter";
import Information from "pages/LandingPages/AboutUs/sections/Information";
import Team from "pages/LandingPages/AboutUs/sections/Team";
import Featuring from "pages/LandingPages/AboutUs/sections/Featuring";
import Newsletter from "pages/LandingPages/AboutUs/sections/Newsletter";
import { useLanguage } from "context/LanguageContext";
import footerRoutes from "footer.routes";
import bgImage from "assets/images/bg-about-us.jpg";
import { ReactComponent as Logo } from "assets/images/macoce-logo.svg";

function AboutUs() {
  const { messages } = useLanguage();

  return (
    <>
      <MKBox component="nav" position="absolute" top="0.5rem" width="100%" zIndex={10}>
        <Container>
          <Grid container flexDirection="row" alignItems="center">
            <MKBox component="a" href="/" sx={{ display: "flex", alignItems: "center", mr: 2 }}>
              <Logo style={{ height: "40px", width: "130px" }} />
            </MKBox>
            <MKBox
              component="ul"
              display={{ xs: "none", lg: "flex" }}
              p={0}
              my={0}
              mx="auto"
              sx={{ listStyle: "none" }}
            >
              <MKBox component="li">
                <MKTypography
                  component="a"
                  href="/"
                  variant="button"
                  color="white"
                  fontWeight="regular"
                  p={1}
                >
                  {messages.nav.home}
                </MKTypography>
              </MKBox>
              <MKBox component="li">
                <MKTypography
                  component="a"
                  href="/construccion"
                  variant="button"
                  color="white"
                  fontWeight="regular"
                  p={1}
                >
                  {messages.pages.items[0].name}
                </MKTypography>
              </MKBox>
              <MKBox component="li">
                <MKTypography
                  component="a"
                  href="/pages/landing-pages/contact-us"
                  variant="button"
                  color="white"
                  fontWeight="regular"
                  p={1}
                >
                  {messages.nav.contact}
                </MKTypography>
              </MKBox>
            </MKBox>
            <MKButton
              variant="gradient"
              color="info"
              component="a"
              href="/pages/landing-pages/contact-us"
              sx={{ ml: { xs: "auto", lg: 0 } }}
            >
              {messages.constructionPage.hero.primaryAction}
            </MKButton>
          </Grid>
        </Container>
      </MKBox>
      <MKBox
        minHeight="78vh"
        width="100%"
        sx={{
          backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
            `${linearGradient(
              rgba(gradients.dark.main, 0.72),
              rgba(gradients.dark.state, 0.72)
            )}, url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "grid",
          placeItems: "center",
        }}
      >
        <Container>
          <Grid container item xs={12} lg={8} flexDirection="column" sx={{ mx: "auto" }}>
            <MKTypography
              variant="button"
              color="info"
              fontWeight="bold"
              textTransform="uppercase"
              mb={2}
            >
              {messages.constructionPage.hero.eyebrow}
            </MKTypography>
            <MKTypography
              variant="h1"
              color="white"
              mb={2}
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              {messages.constructionPage.hero.title}
            </MKTypography>
            <MKTypography variant="body1" color="white" opacity={0.88} mb={4} pr={{ md: 12 }}>
              {messages.constructionPage.hero.description}
            </MKTypography>
            <MKBox display="flex" flexWrap="wrap" gap={2}>
              <MKButton
                variant="gradient"
                color="info"
                component="a"
                href="/pages/landing-pages/contact-us"
              >
                {messages.constructionPage.hero.primaryAction}
              </MKButton>
              <MKButton
                variant="outlined"
                color="white"
                component="a"
                href="/pages/landing-pages/contact-us"
              >
                {messages.constructionPage.hero.secondaryAction}
              </MKButton>
            </MKBox>
          </Grid>
        </Container>
      </MKBox>
      <Card
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <Information />
        <Team />
        <Featuring />
        <Newsletter />
      </Card>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes(messages)} />
      </MKBox>
    </>
  );
}

export default AboutUs;
